import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "_mt-4" }
const _hoisted_2 = {
  class: "gfu-1of1 gfu-1of2--m",
  "data-qa": "order-details:shippingAddress"
}
const _hoisted_3 = { class: "gfu-heading gfu-heading--top-divider _pb-3" }
const _hoisted_4 = {
  class: "gfu-1of1 gfu-1of2--m",
  "data-qa": "order-details:billingAddress"
}
const _hoisted_5 = { class: "gfu-heading gfu-heading--top-divider _pb-3" }
const _hoisted_6 = {
  key: 0,
  class: "gfu-1of1 gfu-1of2--s _fc"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_address_display = _resolveComponent("address-display")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass($options.addressWrapperClasses)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.Resources.YourPledge.ShippingAddressHeader), 1 /* TEXT */),
        _createVNode(_component_address_display, { address: $props.shippingAddress }, null, 8 /* PROPS */, ["address"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.Resources.YourPledge.BillingAddressHeader), 1 /* TEXT */),
        _createVNode(_component_address_display, { address: $props.billingAddress }, null, 8 /* PROPS */, ["address"])
      ])
    ], 2 /* CLASS */),
    ($props.canChangeShippingAddress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_base_button, {
            theme: "primary",
            display: "fixed",
            onClick: _withModifiers($options.changeShipping, ["prevent"]),
            "data-qa": "order-details:ChangeShipping"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.ManageShippingButton), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}